/**
 * 服务文件
 * created by lzy 2020.03.19
 */

'use strict';
angular.module('dateReminderServiceModule', ['createNewScheduleModule']).factory('dateReminderService', ['$q', '$modal',
    function($q, $modal) {
        return {
            createNewSchedule: function(userInfo, schedule) {
                var defer = $q.defer();
                var pathObj = {
                    '1': './dateReminder/service/createNewSchedule/createNewSchedule.html',
                    '4': './dateReminder/service/createNewSchedule/createNewsCalendar.html'
                }
                var modalInstance = $modal.open({
                    templateUrl: pathObj[schedule.type],
                    windowClass: 'createNewScheduleDialog',
                    backdrop: false,
                    controller: 'createNewScheduleCtrl',
                    resolve: {
                        userInfo: function() {
                            return userInfo;
                        },
                        schedule: function() {
                            return schedule;
                        }
                    },
                });
                modalInstance.result.then(function (data) {
                    defer.resolve(data);
                });
                return defer.promise;
            }
        };
    }
]);
